import type { ConnectionStatus } from "@tutor/live";
import { useEffect } from "react";
import { useT } from "../i18n";

// Calm, small and only when it matters. Offline is not an error for the child: answers
// are still checked on the device and messages wait in the outbox.

export function ConnectionBanner(props: {
  status: ConnectionStatus;
  queued: number;
  onUnauthorized: () => void;
}) {
  const { status, queued, onUnauthorized } = props;
  const t = useT();

  useEffect(() => {
    if (status === "unauthorized") onUnauthorized();
  }, [status, onUnauthorized]);

  switch (status) {
    case "live":
      return null;
    case "connecting":
      // Shown only after a short delay (CSS), so a quick reconnect never flashes.
      return (
        <div className="banner reconnecting" role="status">
          <span className="banner-dot" aria-hidden="true" />
          {t("connection.reconnecting")}
        </div>
      );
    case "offline":
      return (
        <div className="banner offline" role="status">
          <span className="banner-dot" aria-hidden="true" />
          <span>{t("connection.offline")}</span>
          {queued > 0 && (
            <span className="banner-count">
              {queued === 1 ? t("connection.queuedOne") : t("connection.queued", { count: queued })}
            </span>
          )}
        </div>
      );
    case "unauthorized":
      return (
        <div className="banner unauthorized" role="status">
          {t("connection.unauthorized")}
        </div>
      );
  }
}
